var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0L3.75 0.625H0V1.875H0.693359L1.80786 11.4099V11.4148C1.88975 12.0315 2.4252 12.5 3.04688 12.5H8.2019C8.82358 12.5 9.35903 12.0315 9.44092 11.4148L9.44214 11.4099L10.5566 1.875H11.25V0.625H7.5L6.875 0H4.375ZM1.95312 1.875H9.29688L8.2019 11.25H3.04688L1.95312 1.875Z",
    fill: "#D83232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTrashIcon);
export default __webpack_public_path__ + "static/media/DeleteTrashIcon.011330d9f57ad68b2648d7d452d11915.svg";
export { ForwardRef as ReactComponent };